export default "__VITE_ASSET__DL0gN5xS__"